export const selectLoanApplication = ({ loanApplication }) => loanApplication;

// Sub-slice selectors that remain referentially stable when unrelated
// slices (e.g. presence) update.  Because combineReducers only replaces
// the parent object, these point directly at the child reference which
// stays the same unless its own reducer returns a new value.
export const selectLoanApplicationBorrowers = ({ loanApplication }) =>
  loanApplication.loanApplicationBorrowers;

export const selectLoanApplicationNonBorrowers = ({ loanApplication }) =>
  loanApplication.loanApplicationNonBorrowers;

export const selectLoanApplicationFinancialInfo = ({ loanApplication }) =>
  loanApplication.financialInfo;
